// URL paths for the three screens, shared by the browser (pushState navigation) and the build-time
// pre-render (one HTML file per path). scripts/serve.mjs maps the same paths to those files.
export type Tab = 'check' | 'bulk' | 'settings';

export interface Route {
  tab: Tab;
  path: string;
  /** Built file in web/dist that serve.mjs sends for this path. */
  file: string;
  label: string;
  title: string;
  description: string;
  /** Kept out of search results (and the sitemap). */
  noindex?: boolean;
}

export const SITE = 'https://serpsizer.com';

export const ROUTES: Route[] = [
  {
    tab: 'check', path: '/', file: 'index.html', label: 'Check',
    title: 'Free SERP Preview Tool & Title Length Checker | SERPsizer',
    description: 'See which words of your title tag and meta description Google cuts off on iPhone, Android, iPad and desktop. Check one page or bulk upload a CSV.',
  },
  {
    tab: 'bulk', path: '/bulk', file: 'bulk.html', label: 'Bulk',
    title: 'Bulk Title & Meta Description Length Checker | SERPsizer',
    description: 'Upload a CSV or crawler export and see which title tags and meta descriptions Google cuts off on iPhone, Android, iPad and desktop, for every page at once.',
  },
  {
    tab: 'settings', path: '/settings', file: 'settings.html', label: 'Settings',
    title: 'Settings · SERPsizer',
    description: 'Choose which devices SERPsizer checks, set your default brand, and adjust when a title or description counts as cut.',
    noindex: true,
  },
];

/** Pages outside the three screens: pre-rendered from web/src/pages, not in the nav, left as the server sent them. */
export interface StaticPage {
  path: string;
  file: string;
  /** HTML fragment in web/src/pages that becomes the page's main content. */
  source: string;
  title: string;
  description: string;
  noindex?: boolean;
}

export const STATIC_PAGES: StaticPage[] = [
  {
    // Unlisted: shared by link only, so it's noindex, out of the sitemap and linked from nowhere.
    path: '/mcp', file: 'mcp.html', source: 'mcp.html',
    title: 'MCP Server · SERPsizer',
    description: 'Connect Claude, Cursor, VS Code or any MCP client to SERPsizer with your API key, and check titles and meta descriptions from your AI assistant.',
    noindex: true,
  },
];

export const NOT_FOUND = { file: '404.html', title: 'Page not found · SERPsizer' };

/** The route for a pathname, ignoring one trailing slash; null for unknown paths. */
export function routeFor(pathname: string): Route | null {
  const p = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return ROUTES.find(r => r.path === p) ?? null;
}

export const routeOf = (tab: Tab): Route => ROUTES.find(r => r.tab === tab)!;
